<template>
  <div class="this-wrapper">
    <div @click="calculateSimpleFrequency(column.id)" class="stats-trigger" :ref="`trigger`">
      <h3 class="question-label">{{column.label ? column.label.substring(0, 20) : '??'}}...</h3>
      <h5 class="question-type">{{column.type}}</h5>
    </div>

    <el-drawer
      :visible="activeColumn === column.id"
      direction="ltr"
      :before-close="beforeClose"
      :size="drawerSize"
      v-on:close="closeDrawer()"
    >
      <div class="admin-inner-page">
        <div class="sensata-splash-wrapper" @click="goToAdmin()">
          <SensataSplash></SensataSplash>
        </div>
      </div>
      <div class="stats-wrapper-inner">
        <h3>{{column.label}} <span class="researchQuestion" v-if="column.researchQuestion">({{column.researchQuestion}})</span></h3>
        <el-row :gutter="10">
          <el-col :xs="24" :lg="12">
            <div class="chart-wrapper">
              <pie
                :chart-data="questionDetail.optionsFrecuencies"
                v-if="questionDetail.optionsFrecuencies && chartType === 'pie'"
              ></pie>
              <bar
                :chart-data="questionDetail.optionsFrecuencies"
                v-if="questionDetail.optionsFrecuencies && chartType === 'bar'"
              ></bar>
              <radar
                :chart-data="questionDetail.optionsFrecuencies"
                v-if="questionDetail.optionsFrecuencies && chartType === 'radar'"
              ></radar>
              <line-chart
                :chart-data="questionDetail.optionsFrecuencies"
                v-if="questionDetail.optionsFrecuencies && chartType === 'line'"
              ></line-chart>
            </div>
          </el-col>
          <el-col :xs="24" :lg="12">
            <div
              v-if="questionDetail.imageQuestion"
              :style="{backgroundImage: `url(${questionDetail.imageQuestion})`}"
              class="image-question"
            ></div>
            <el-table
              class="stats-wrapper-inner-table"
              :data="tableDetail"
              style="width: 100%">
              <el-table-column
                prop="label"
                label="Resumen"
                min-width="160">
              </el-table-column>
              <el-table-column
                prop="value"
                min-width="140">
              </el-table-column>
            </el-table>
            <el-table
              class="responses-table stats-wrapper-inner-table"
              :data="responsesTable"
              style="width: 100%">
              <el-table-column
                prop="label"
                label="Opciones"
                min-width="160">
                <template slot-scope="scope">
                  <div v-if="!scope.row.url && !scope.row.emoji">
                    {{scope.row.label}}
                  </div>
                  <div v-if="scope.row.url">
                    <el-popover
                      placement="left"
                      width="200"
                      trigger="hover"
                      :visible-arrow="false"
                    >
                      <div slot="reference">
                        <div
                          :style="{backgroundImage: `url(${scope.row.url})`}"
                          class="reference-image"
                        ></div>
                      </div>
                      {{scope.row.label}}
                    </el-popover>
                  </div>
                  <div v-if="scope.row.emoji">
                    <el-popover
                      placement="left"
                      width="200"
                      trigger="hover"
                      :visible-arrow="false"
                    >
                      <div slot="reference">
                        <Icons class="icon" :icon="scope.row.emoji" size="70" color="#5d2466"></Icons>
                      </div>
                      {{scope.row.label}}
                    </el-popover>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="Respuestas"
                prop="value"
                min-width="140">
                <template slot-scope="scope">
                  {{scope.row.value}}
                  <div class="align-right">({{scope.row.share}})</div>
                </template>
              </el-table-column>
              <el-table-column
                label=""
                prop="share"
                min-width="140">
                <template slot-scope="scope">
                  <div class="share-bar-wrapper">
                    <div class="share-bar" :style="{width: `${scope.row.share.substring(0, scope.row.share.length - 1)}%`}">
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import * as ss from 'simple-statistics'
import VueCharts from 'vue-chartjs'
var randomColor = require('randomcolor')

export default {
  name: 'MultiTextStats',

  props: ['column', 'dataSet', 'entries'],

  data () {
    return {
      chartType: 'pie',
      activeColumn: null,
      questionDetail: {},
      allResponses: [],
      responsesTable: [],
      tableDetail: []
    }
  },

  components: {
    SensataSplash: () => import('Components/base/SensataSplash'),
    Pie: () => import('Components/charts/Pie'),
    LineChart: () => import('Components/charts/Line'),
    Bar: () => import('Components/charts/Bar'),
    Radar: () => import('Components/charts/Radar'),
    Icons: () => import('Components/base/Icons')
  },

  mounted () {
    document.addEventListener('keyup', this.handleKeyup)
  },

  destroyed () {
    document.removeEventListener('keyup', this.handleKeyup)
  },

  methods: {
    openQuestion (id) {
      this.calculateSimpleFrequency(id)
    },
    handleKeyup (event) {
      if (event.keyCode === 27) {
        this.closeDrawer()
      }
      var active = -1
      if (event.keyCode === 37 || event.keyCode === 39) {
        this.dataSet.forEach((q, index) => {
          if (q.sys.id === this.activeColumn) {
            active = index
          }
        })
        this.closeDrawer()
        if (active === -1) return
        if (event.keyCode === 37) {
          if (active > 1) {
            this.$emit('open:trigger', this.dataSet[active - 1].sys.id)
          }
        } else {
          if (event.keyCode === 39) {
            if (active < this.dataSet.length - 1) {
              setTimeout(() => {
                this.$emit('open:trigger', this.dataSet[active + 1].sys.id)
              }, 100)
            }
          }
        }
      }
    },
    beforeClose (done) {
      // this.activeColumn = null
      this.questionDetail.optionsFrecuencies = {
        datasets: [],
        labels: []
      }

      done()
    },
    closeDrawer () {
      this.activeColumn = null
      this.responsesTable = []
    },
    latinize (input) {
      if (typeof input === 'string') {
        return input.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
      }
      return input
    },
    calculateSimpleFrequency (columnId) {
      this.activeColumn = columnId
      var question = this.dataSet.filter(question => {
        return question.sys.id === columnId
      })

      if (question.length) {
        // get the location of this questionId in the entries set, using a loop to allow for different sets
        var index = -1
        this.entries.forEach((responseSet, i) => {
          responseSet.responses.forEach((entry, j) => {
            if (entry && entry.id === columnId) {
              index = j
              return
            }
          })
          if (index > -1) return
        })

        if (index > -1) {
          /* 
           * This section calculates the basic stats per question that are used in both the details table and the chart)
           */
          var emojiOptions = ['emoji-heart', 'emoji-hug', 'emoji-yummy', 'emoji-cool', 'emoji-grimace', 'emoji-dizzy']
          this.questionDetail.question = this.dataSet[index]
          var allResponses = []
          var allTimes = []
          // get all the responses to this question
          this.entries.forEach((entry, i) => {
            if (entry.responses[index] && entry.responses[index].id === columnId) {
              if (entry.responses[index].selected[0] === 'next') {
                allResponses.push('Siguiente')
              } else {
                if (typeof entry.responses[index].selected === 'object') {
                  allResponses.push(entry.responses[index].selected.join(','))
                } else {
                  allResponses.push(entry.responses[index].selected)
                }
              }
              allTimes.push(entry.responses[index].timeToCompletion)
            }
          })
          var allResponsesExtended = []
          var responsesTableCount = []
          allResponses.forEach((response, index) => {
            var individualResponses = typeof response === 'number' ? response : response.split(',')
            if (individualResponses.length) {
              individualResponses.forEach(item => {
                allResponsesExtended.push(this.latinize(item))
              })
            } else {
              allResponsesExtended.push(this.latinize(response))
            }
          })
          allResponsesExtended.forEach((response, index) => {
            responsesTableCount[response] = responsesTableCount[response] ? responsesTableCount[response] + 1 : 1
          })

          this.questionDetail.responses = allResponses

          // add simple statistics
          this.questionDetail.mode = ss.modeFast(allResponses)
          this.questionDetail.median = ss.median(allResponses)
          this.questionDetail.min = ss.min(allResponses)
          this.questionDetail.max = ss.max(allResponses)
          this.questionDetail.averageTime = ss.mean(allTimes)
          this.questionDetail.count = allResponses.length

          this.tableDetail = [] // clean before adding new ones
          this.tableDetail.push({
            label: 'Total de respuestas',
            value: allResponsesExtended.length === allResponses.length ? allResponses.length : `${allResponses.length} (${allResponsesExtended.length})`
          })
          this.tableDetail.push({
            label: 'Tiempo promedio',
            value: this.$options.filters.msToMinutes(ss.mean(allTimes))
          })
          this.tableDetail.push({
            label: 'Dato más repetido',
            value: ss.modeFast(allResponses)
          })

          // calculate simple frecuencies
          var optionsFrecuenciesLabels = []
          var optionsFrecuenciesValues = []

          /*
           * This section adds the table that is displayed below the question image, with the summary/table details)
           */
          // get the frecuencies for each response
          for (let [key, value] of Object.entries(responsesTableCount)) {
            if (question[0].sys.contentType.sys.id === 'slider' && question[0].fields.useTextScale) {
              this.responsesTable.push({
                label: key !== 'S99' ? question[0].fields.textScale[key - 1] : 'S99',
                value: value,
                share: `${Math.round(value / allResponsesExtended.length * 10000) / 100}%`
              })
            } else {
              var filtered = []
              var emojis = []
              var emojiBubbles = []
              if (question[0].fields.optionsImages) {
                filtered = question[0].fields.optionsImages.filter(image => { return this.latinize(image.fields.title) === this.latinize(key) })
              }
              var label = key
              if (question[0].fields.textScale) {
                if (parseInt(key, 10) === 1) {
                  label = `${key} (${question[0].fields.textScale[0]})`
                }
                if (parseInt(key, 10) === question[0].fields.steps) {
                  label = `${key} (${question[0].fields.textScale[1]})`
                }
              }

              if (question[0].sys.contentType.sys.id === 'emoji') {
                var options = ['emoji-heart', 'emoji-hug', 'emoji-yummy', 'emoji-cool', 'emoji-grimace', 'emoji-dizzy']
                emojis = options.filter(option => { return this.latinize(option) === this.latinize(key) })
              }

              if (question[0].sys.contentType.sys.id === 'emojiBubbles') {
                var options = ['1', '2', '3', '4', '5']
                emojiBubbles = options.filter(option => { return this.latinize(option) === this.latinize(key) })
              }

              if (question[0].sys.contentType.sys.id === 'emojiSlider') {
                if (parseInt(key, 10) === 1) {
                  filtered = [question[0].fields.fromEmoji]
                }
                if (parseInt(key, 10) === question[0].fields.steps) {
                  filtered = [question[0].fields.toEmoji]
                }
              }

              this.responsesTable.push({
                label: label,
                value: value,
                share: `${Math.round(value / allResponsesExtended.length * 10000) / 100}%`,
                url: filtered.length ? filtered[0].fields.file.url : '',
                emoji: emojis.length ? `${emojis[0]}` : '',
                emojiBubbles: emojis.length ? `emoji-bubble-${emojiBubbles[0]}` : ''
              })
            }
          }

          /*
           * This section adds the missing options (if they are not found in the responses)
           */
          // If this has an options field, like the emoji
          if (question[0].sys.contentType.sys.id === 'emoji') {
            emojiOptions.forEach(option => {
              if (JSON.stringify(allResponses).indexOf(option) === -1) {
                this.responsesTable.push({
                  label: option,
                  value: 0,
                  share: `0.00%`
                })
              }
            })
          }
          // If this has an option scale like the emojiBubbles
          if (question[0].sys.contentType.sys.id === 'emojiBubbles') {
            var options = [1, 2, 3, 4, 5]
            options.forEach(option => {
              if (JSON.stringify(allResponses).indexOf(option) === -1) {
                this.responsesTable.push({
                  label: option,
                  value: 0,
                  share: `0.00%`,
                  emoji: `emoji-bubble-${option}`
                })
              }
            })
          }
          // If this has an options field, like the MultiText
          if (question[0].fields.options) {
            question[0].fields.options.forEach(option => {
              if (JSON.stringify(allResponses).indexOf(option) === -1) {
                this.responsesTable.push({
                  label: option,
                  value: 0,
                  share: `0.00%`
                })
              }
            })
          }
          // If this has an optionsImages field, like the Bilderset
          if (question[0].fields.optionsImages) {
            question[0].fields.optionsImages.forEach(option => {
              if (JSON.stringify(allResponses).indexOf(option.fields.title) === -1) {
                this.responsesTable.push({
                  label: option.fields.title,
                  value: 0,
                  share: `0.00%`,
                  url: option.fields.file.url
                })
              }
            })
          }
          // If this is emojibubbles or likert
          if (question[0].sys.contentType.sys.id === 'likertBubbles' || question[0].sys.contentType.sys.id === 'rating') {
            this.chartType = 'bar' // set the chart type
            for (var i = 1; i <= 5; i++) {
              if (JSON.stringify(allResponses).indexOf(i) === -1) {
                var label = i
                if (question[0].fields.textScale) {
                  if (parseInt(i, 10) === 1) {
                    label = `${i} (${question[0].fields.textScale[0]})`
                  }
                  if (parseInt(i, 10) === question[0].fields.steps) {
                    label = `${i} (${question[0].fields.textScale[1]})`
                  }
                }
                this.responsesTable.push({
                  label: label,
                  value: 0,
                  share: `0.00%`
                })
              }
            }
          }

          // If this is NPS
          if (question[0].sys.contentType.sys.id === 'netPromoterScore') {
            this.chartType = 'bar' // set the chart type
            for (var i = 1; i <= 10; i++) {
              if (JSON.stringify(allResponses).indexOf(i) === -1) {
                var label = i
                this.responsesTable.push({
                  label: label,
                  value: 0,
                  share: `0.00%`
                })
              }
            }
          }

          // If this is a slider
          if (question[0].sys.contentType.sys.id === 'slider') {
            this.chartType = 'bar' // set the chart type
            if (question[0].fields.useTextScale) {
              for (var i = question[0].fields.from; i <= question[0].fields.to; i++) {
                if (JSON.stringify(allResponses).indexOf(i) === -1) {
                  this.responsesTable.push({
                    label: question[0].fields.textScale[i - 1],
                    value: 0,
                    share: `0.00%`
                  })
                }
              }
            } else {
              for (var i = question[0].fields.from; i <= question[0].fields.to; i++) {
                if (JSON.stringify(allResponses).indexOf(i) === -1) {
                  this.responsesTable.push({
                    label: i,
                    value: 0,
                    share: `0.00%`
                  })
                }
              }
            }
          }

          // sort by share
          this.responsesTable.sort((a, b) => {
            return b.share.slice(0, -1) - a.share.slice(0, -1)
          })

          /*
           * This section provides the chart with data
           */
          if (question) {
            // Add an image on top of the tables if there's a questionImage field
            if (question[0].fields.questionImage) {
              this.questionDetail.imageQuestion = question[0].fields.questionImage.fields.file.url
            }

            // If this has an options array, like the emoji
            if (question[0].sys.contentType.sys.id === 'emoji') {
              emojiOptions.forEach(option => {
                var count = allResponses.filter(response => {
                  // legacy code for older versions
                  if (typeof response === 'object') {
                    return response[0] === option
                  }
                  return response === option
                })
                optionsFrecuenciesValues.push(count.length)
                optionsFrecuenciesLabels.push(option)
              })
            }
            // If this has an options field, like the MultiText
            if (question[0].fields.options) {
              question[0].fields.options.forEach(option => {
                var count = allResponses.filter(response => {
                  // legacy code for older versions
                  if (typeof response === 'object') {
                    return response[0] === option
                  }
                  return response === option
                })
                optionsFrecuenciesValues.push(count.length)
                optionsFrecuenciesLabels.push(option)
              })
            }
            // If this has an optionsImages field, like the Bilderset
            if (question[0].fields.optionsImages) {
              question[0].fields.optionsImages.forEach(option => {
                var count = allResponsesExtended.filter(response => {
                  // legacy code for older versions
                  if (typeof response === 'object') {
                    return this.latinize(response[0]) === this.latinize(option.fields.title)
                  }
                  return this.latinize(response) === this.latinize(option.fields.title)
                })
                optionsFrecuenciesValues.push(count.length)
                optionsFrecuenciesLabels.push(option.fields.title)
              })
            }
            // If this is an emojiBubble or likert
            if (question[0].sys.contentType.sys.id === 'emojiBubbles' || question[0].sys.contentType.sys.id === 'likertBubbles') {
              for (var i = 1; i <= 5; i++) {
                var count = allResponses.filter(response => {
                  return parseInt(response, 10) === i
                })
                optionsFrecuenciesValues.push(count.length)
                optionsFrecuenciesLabels.push(i)
              }
            }
            // If this is a dilemma
            if (question[0].sys.contentType.sys.id === 'dilemma') {
              question[0].fields.textOptions.forEach(option => {
                var count = allResponses.filter(response => {
                  // Legacy code for older versions
                  if (typeof response === 'object') {
                    return response[0] === option
                  }
                  return response === option
                })
                optionsFrecuenciesValues.push(count.length)
                optionsFrecuenciesLabels.push(option)
              })
            }
            // If this is thumbs
            if (question[0].sys.contentType.sys.id === 'thumbs') {
              var countDown = allResponses.filter(response => {
                // Legacy code for older versions
                if (typeof response === 'object') {
                  return response[0] === 'down'
                }
                return response === 'down'
              })
              optionsFrecuenciesValues.push(countDown.length)
              optionsFrecuenciesLabels.push('down')
              var countUp = allResponses.filter(response => {
                // Legacy code for older versions
                if (typeof response === 'object') {
                  return response[0] === 'up'
                }
                return response === 'up'
              })
              optionsFrecuenciesValues.push(countUp.length)
              optionsFrecuenciesLabels.push('up')
              var countNA = allResponses.filter(response => {
                // Legacy code for older versions
                if (typeof response === 'object') {
                  return response[0] === 'S99'
                }
                return response === 'S99'
              })
              optionsFrecuenciesValues.push(countNA.length)
              optionsFrecuenciesLabels.push('S99')
            }
            // If this is a slider
            if (question[0].sys.contentType.sys.id === 'slider') {
              if (question[0].fields.useTextScale) {
                for (var i = question[0].fields.from; i <= question[0].fields.to; i++) {
                  var count = allResponses.filter(response => {
                    return parseInt(response, 10) === i
                  })
                  optionsFrecuenciesValues.push(count.length)
                  optionsFrecuenciesLabels.push(question[0].fields.textScale[i - 1])
                }
                optionsFrecuenciesValues.push(0)
                optionsFrecuenciesLabels.push('')
              } else {
                for (var i = question[0].fields.from; i <= question[0].fields.to; i++) {
                  var count = allResponses.filter(response => {
                    return parseInt(response, 10) === i
                  })
                  optionsFrecuenciesValues.push(count.length)
                  optionsFrecuenciesLabels.push(i)
                }
              }
            }
            // If this is a NPS
            if (question[0].sys.contentType.sys.id === 'netPromoterScore') {
              for (var i = 1; i <= 10; i++) {
                var count = allResponses.filter(response => {
                  return parseInt(response, 10) === i
                })
                optionsFrecuenciesValues.push(count.length)
                optionsFrecuenciesLabels.push(i)
              }
              optionsFrecuenciesValues.push(0)
              optionsFrecuenciesLabels.push('')
            }
            // If this is emojiSlider
            if (question[0].sys.contentType.sys.id === 'emojiSlider') {
              for (var i = 1; i <= question[0].fields.steps; i++) {
                var count = allResponses.filter(response => {
                  return parseInt(response, 10) === i
                })
                optionsFrecuenciesValues.push(count.length)
                optionsFrecuenciesLabels.push(i)
              }
              optionsFrecuenciesValues.push(0)
              optionsFrecuenciesLabels.push('')
            }
            // If this is a rating
            if (question[0].sys.contentType.sys.id === 'rating') {
              for (var i = 1; i <= 5; i++) {
                var count = allResponses.filter(response => {
                  return parseInt(response, 10) === i
                })
                optionsFrecuenciesValues.push(count.length)
                optionsFrecuenciesLabels.push(i)
              }
            }
            // graph this optionsFrecuencies...
            this.questionDetail.optionsFrecuenciesValues = optionsFrecuenciesValues
            this.questionDetail.optionsFrecuenciesLabels = optionsFrecuenciesLabels
            this.questionDetail.optionsFrecuencies = {
              datasets: [{
                backgroundColor: this.randomColors,
                data: optionsFrecuenciesValues,
                label: 'Dataset'
              }],
              labels: optionsFrecuenciesLabels
            }
          }
        } else {
          return
        }
      }
      this.questionDetail.columnId = columnId
    }
  },
  computed: {
    drawerSize () {
      if (this.$isMobile()) {
        return '90%'
      }
      return '70%'
    },
    randomColors () {
      var colorList = randomColor({
        count: 100,
        format: 'rgba',
        alpha: 0.8
      })

      var base = [ '#f56c6c', '#5d2466', '#88d8b0', '#5C80BC', 'orange', 'red', 'violet', 'cyan', 'blue', 'green', 'brown' ]

      return base.concat(colorList)
    }
  }
}
</script>

<style lang="scss">
.researchQuestion {
  text-transform: lowercase;
  font-size: 0.8em;
  color: rgba($gray-medium, 0.5);
  font-weight: normal;
  font-style: italic;
}
.this-wrapper {
  padding: 0 !important;
  div {
    padding: 0 !important;
  }
  .el-table th > .cell {
    padding-left: 0 !important;
  }
}
.admin-inner-page {
  .sensata-splash-wrapper {
    font-size: 0.4em;
    margin-left: 2.5em;
    position: fixed;
    top: 0;
    @include breakpoint($tablet) {
      margin-left: 1.3em;
      font-size: 1em;
    }
  }
}
.popper__arrow {
  display: none;
}
.el-drawer.ltr {
  max-width: 1200px !important;
}
.el-table .cell {
  word-break: break-word;
}
</style>
<style scoped lang="scss">
.reference-image,
.image-question {
  width: 150px;
  height: 120px;
  background-size: cover;
  background-position: center center;
  border: 1px solid $gray-light;
}
.image-question {
  margin-bottom: 1em;
  margin-top: 2em;
  width: 100%;
  padding-bottom: 75%;
  height: 0;
  @include breakpoint($tablet) {
    margin-top: 0;
  }
}
.chart-wrapper {
  max-width: 400px;
}
.stats-wrapper-inner {
  border-top: 1px #f0f0f0 solid;
  padding: 0 2em;
  font-size: 0.6em;
  @include breakpoint($fullhd) {
    margin-top: 2em;
  }
}
.stats-wrapper-inner-table {
  @include breakpoint($fullhd) {
    font-size: 0.7em;
  }
}
.stats-trigger {
  &:hover {
    cursor: pointer;
  }
}

.question-label {
  margin-bottom: 0;
  padding: 0;
  font-size: 1em;
  min-width: 200px;
}
.question-type {
  font-size: 0.6em;
  text-transform: uppercase;
  line-height: 1;
  font-style: italic;
  margin: 0;
  padding: 0;
  @include breakpoint($tablet) {
    font-size: 0.3em;
  }
}
.responses-table {
  margin-top: 2em;
}
.share-bar-wrapper {
  position: relative;
  width: 100%;
  height: 1.2em;

  .share-bar {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    height: 100%;
    background: rgba($gray-medium, 0.69);
  }
}
.align-right {
  text-align: right;
  position: absolute;
  right: 0;
  display: inline;
}
</style>
